// Material
import { List } from '@mui/material'
import { styled } from '@mui/material/styles'
// Localization
import { t } from '$i18n'
import { openRoom } from '$logic/opened-room'
import { usePvByUserId } from '$logic/pv/react-hook'
import { getPvByUserId } from '$logic/pv'
import { openSharedMedia } from '$logic/router'
import { ChatProfileActionItem } from '$common/chat-profile-action-item'
import { WChatOutlinedIcon, WPhotoIcon } from '@weblite/icons'

const StyledList = styled(List)`
  padding-top: 0;
  padding-bottom: 0;
  background-color: white;
  margin-top: 10px;
`

interface Prop {
  userId: string
}

export function UserProfileActions({ userId }: Prop) {
  const { pv } = usePvByUserId(userId)
  const onSendMessage = async () => {
    const { roomId } = pv || (await getPvByUserId(userId))!
    openRoom(roomId)
  }

  const onSharedMedia = async () => {
    const { roomId } = pv || (await getPvByUserId(userId))!
    openSharedMedia(roomId)
    analite('CHAT_SHARED_MEDIA_CLICK', { type: 'PV' })
  }

  return (
    <StyledList>
      <ChatProfileActionItem
        Icon={<WChatOutlinedIcon />}
        onClick={onSendMessage}
        iconBgColor="primary500"
      >
        {t('profile.user.sendMessage')}
      </ChatProfileActionItem>
      {pv && (
        <ChatProfileActionItem
          Icon={<WPhotoIcon />}
          iconBgColor="yellow700"
          onClick={onSharedMedia}
        >
          {t('profile.common.sharedMedia')}
        </ChatProfileActionItem>
      )}
    </StyledList>
  )
}
